import React from 'react';
import classNames from 'classnames';
import { Icon, makeStyles, Skeleton } from '~/lib/bn-material-ui';
import { useSirenEntity } from '~/utility/BinSentry-ui-utility';

const useStyles = makeStyles(() => ({
  icon: {
    marginLeft: '0.5rem',
    fontSize: 'inherit',
  },
}));

export function OrderFeedType({ orderEntity, iconClassName, unknownFeedTypeText = 'unknown' }) {
  const { entity: feedEntity, loading: loadingFeed } = useSirenEntity({ href: orderEntity?.getSubEntityByRel('https://api.binsentry.com/rel/feed')?.href });
  const styles = useStyles();

  if (!orderEntity || loadingFeed) {
    return <Skeleton variant='text' />;
  }

  const { feedType } = feedEntity?.properties || {};
  const { medicated } = orderEntity.properties || {};
  const feedTypeDisplay = feedType || unknownFeedTypeText;

  return (
    <>
      {feedTypeDisplay}
      {medicated && <Icon className={classNames('fad', 'fa-prescription-bottle-alt', styles.medicatedIcon, iconClassName)} />}
    </>
  );
}
